module.exports = __webpack_public_path__ + "res/img_audio_poster.5c23dfa8c8b2cbc9cdc1f098bd3c043e.gif";